/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wLjUgMC41SDExLjVWMS41SDEuNVYxMS41SDAuNVYwLjVaTTQuNSA0LjVWMTUuNUgxNS41VjQuNUg0LjVaTTE0LjUgMTQuNUg1LjVWNS41SDE0LjVWMTQuNVoiIGZpbGw9ImluaGVyaXQiLz4=";